import { Component, Input, Output, EventEmitter, Inject, PLATFORM_ID, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Question } from 'src/app/models/question';
import { Router } from '@angular/router';
import { SafePipe } from 'src/app/pipes/safe.pipe';

@Component({
    selector: 'app-survey-question',
    templateUrl: './survey-question.component.html',
    styleUrls: ['./survey-question.component.scss'],
    imports: [SafePipe,CommonModule],
     changeDetection: ChangeDetectionStrategy.Default
})
export class SurveyQuestionComponent {

  @Input() question: Question
  @Input() surveyResultId: number
  @Output() answered: EventEmitter<any> = new EventEmitter();
  questionNumber
  selectedAnswer = []
  answerChoices

  answeredIndex = null


  constructor( private router: Router, @Inject(PLATFORM_ID) private platformId: Object) { }

  openModal() {
    if (isPlatformBrowser(this.platformId)) {
      const modalElement = document.getElementById('hintModal');
      if (modalElement) {
        const { Modal } = require('bootstrap');
        Modal.getOrCreateInstance(modalElement).show();
      }
    }
  }


  
  checkStorageForPreviouslyAnsweredValue(){
// $&("survey-question > this.question.questionNumber",this.question.questionNumber)
// $&("survey-question > this.surveyResultId",this.surveyResultId)

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    var key: string = this.surveyResultId.toString() + "_" + (this.question.questionNumber - 1).toString()

// $&("checking to see if 'key' has been answered", key)

    var hasBeenAnswered = localStorage.getItem(key)

    if (hasBeenAnswered != null) {     
      this.answeredIndex = hasBeenAnswered.charCodeAt(0)-65;
// $&("'key' was found in localStorange. value, answeredIndex", hasBeenAnswered, this.answeredIndex)
    }
    else{
      //There has not been a previously selected answer. Clear the answered index so that no choice is preselected
      this.answeredIndex=null;
    }

    // console.log(hasBeenAnswered, key, hasBeenAnswered.charCodeAt(0)-65)
  }

  //ngDoCheck(){ //WHY?
  ngOnChanges(changes:SimpleChanges){
// $&("survey question component detected changes", changes)
    if(changes.question.currentValue.questionNumber != this.questionNumber){
      this.questionNumber = changes.question.currentValue.questionNumber;
      this.checkStorageForPreviouslyAnsweredValue();
    }
  }

  Answer(question) { 
    
// $&("survey-question > Answer(question)", question)

  const alpha = String.fromCharCode(65 + question) // converts index to letter

    this.answered.emit(alpha)

    // this.question[this.answerChoices].text = this.selectedAnswer;
    // localStorage.setItem('question', JSON.stringify(this.question))
    // this.questionNumber++
    // localStorage.setItem('questionNumber', this.question.questionNumber.toString())
    // if (this.question.questionNumber == 10) {
    //   this.router.navigate(['/result']);
    // }
  }

}
